const NAME = "CURRENT_PROCESSES_PAGE";

export default NAME;
